import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "height", "width", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaSizer = _resolveComponent("MediaSizer")!
  const _component_MediaContainer = _resolveComponent("MediaContainer")!

  return (_openBlock(), _createBlock(_component_MediaContainer, { fill: _ctx.fill }, {
    default: _withCtx(() => [
      _createVNode(_component_MediaSizer, {
        width: _ctx.width,
        height: _ctx.height,
        layout: _ctx.layout
      }, null, 8, ["width", "height", "layout"]),
      _createElementVNode("img", {
        src: _ctx.src,
        height: _ctx.height,
        width: _ctx.width,
        alt: _ctx.alt,
        loading: "lazy",
        decoding: "async"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["fill"]))
}